import React, { useRef, useState, useEffect } from 'react';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { API_BASE_URL } from './config';
import './CategoryBar.css';

// Fallback static categories shown while API loads or on failure
const FALLBACK_CATEGORIES = ['All'];

export default function CategoryBar({ selectedCategory = 'All', onSelectCategory }) {
  const scrollRef = useRef(null);
  const [categories, setCategories] = useState(FALLBACK_CATEGORIES);

  // Fetch live categories from njsapitube backend
  useEffect(() => {
    let cancelled = false;
    async function loadCategories() {
      try {
        const res = await fetch(`${API_BASE_URL}/api/v1/categories`, {
          headers: {
            token: 'c7e993808a344da9d59cfa20fa8b6061',
            devicetype: '0',
            request_type: 'USER',
          },
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        const raw = json?.data?.categories || [];
        if (!cancelled && raw.length > 0) {
          // Always keep 'All' first, then live category names
          const names = ['All', ...raw.filter(c => c.is_active).map(c => c.name)];
          setCategories(names);
        }
      } catch (err) {
        console.warn('CategoryBar: could not load categories from API:', err);
        // Keep fallback — do nothing
      }
    }
    loadCategories();
    return () => { cancelled = true; };
  }, []);

  const handleScroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === 'left' ? -280 : 280;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <div className="yt-category-bar-wrapper">
      <button
        className="yt-category-scroll-btn left"
        onClick={() => handleScroll('left')}
        title="Previous categories"
        aria-label="Previous categories"
      >
        <MdChevronLeft size={24} />
      </button>

      <div className="yt-category-bar" ref={scrollRef}>
        {categories.map((name) => {
          const isSelected = selectedCategory === name;
          return (
            <button
              key={name}
              className={`yt-chip ${isSelected ? 'active' : ''}`}
              onClick={() => onSelectCategory && onSelectCategory(name)}
            >
              {name}
            </button>
          );
        })}
      </div>

      <button
        className="yt-category-scroll-btn right"
        onClick={() => handleScroll('right')}
        title="Next categories"
        aria-label="Next categories"
      >
        <MdChevronRight size={24} />
      </button>
    </div>
  );
}
